import React, {memo} from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import {Checkbox} from '@vio/atlas/Checkbox'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {cssTheme} from '@vio/atlas/themes'

import {filterMessages} from '../filterMessages'

const Wrapper = styled.div`
  display: grid;
  grid-gap: ${cssTheme.layout.spacing.s500};
`
interface Props {
  amenities: string[] | undefined
  /** The callback fired on filter change */
  onChange: (filterName: string, filterValue: string | null | undefined) => void
}
const MealPlansFilterComponent: React.FC<Props> = ({amenities, onChange}) => {
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()

  return (
    <Wrapper>
      <Checkbox
        key="breakfast"
        name="breakfast"
        value="breakfast"
        checked={amenities?.includes('breakfast')}
        onChange={() => onChange('amenities', 'breakfast')}
        label={formatMessage(filterMessages.breakfast)}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
      <Checkbox
        key="allInclusive"
        name="allInclusive"
        value="allInclusive"
        checked={amenities?.includes('allInclusive')}
        onChange={() => onChange('amenities', 'allInclusive')}
        label={formatMessage(filterMessages.allInclusive)}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
    </Wrapper>
  )
}

export const MealPlansFilter = memo(MealPlansFilterComponent)
